import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../assets/css/styles_bootstrap.scss'
import '../assets/css/base.css'
import '../assets/css/colors.css'

Vue.use(BootstrapVue)

import '../assets/css/font.css'
import '../assets/css/dictionary.css'
